











import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'
import Player from '@vimeo/player'

@Component
export default class Video extends Vue {
  player = null
  playing = false
  volume = 0
  show = false

  @Prop({ type: String }) url: string
  @Prop({ type: Boolean }) current: boolean

  @Action('setDarkMode') setDarkMode
  @Action('setLightMode') setLightMode

  @Watch('current', { immediate: true })
  setCurrent(current) {
    this.show = current
    // if (this.show && this.player) {
    //   this.player.play()
    // } else
    if (!this.show && this.playing) {
      this.player.pause()
    }
  }

  @Watch('playing', )
  setMode(playing) {
    if (this.playing) {
      this.setDarkMode()
    } else {
      this.setLightMode()
    }
  }

  @Watch('volume', { immediate: true })
  updateVolume(volume) {
    if (this.player) {
      this.player.setVolume(volume)
    }
  }

  mounted() {

    this.volume = 1
    const iframe = this.$refs.player
    this.player = new Player(iframe)
    this.player.setVolume(this.volume)

    this.player.on('play', () => {
      this.playing = true
    })

    this.player.on('pause', () => {
      this.playing = false
    })
  }


}
